import { PrebookHotelSummaryModel, PrebookLeadPaxModel } from '@/__generated';
import { getFullName } from '@/helpers/string';
import React from 'react';
import LabelValueItem from './LabelValueItem';

type Props = {
  bookingSummary: PrebookHotelSummaryModel;
};

export default function ReadOnlyAgentBookingInfo({ bookingSummary }: Props) {
  return (
    <div className="row x-gap-10 y-gap-10 mt-20">
      <div className="col-12 d-flex align-items-center mb-10">
        <div className="fw-bold text-18 text-blue-1  rounded-2 pr-10 text-uppercase">Agent Remark</div>
        <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
      </div>
      <div className="col-md-6 col-xs-12">
        <LabelValueItem label="Agent booking ref" value={bookingSummary.agentBookingRef} />
      </div>
    </div>
  );
}
